import { createContext } from 'react';

export const AlertContext = createContext();
export const AuthContext = createContext();
export const DebuggingContext = createContext(false);
export const MapContext = createContext();

export const DataContext = createContext([]);

